import Vue from 'vue'
import CoreuiVue from '@coreui/vue/src'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'

import App from './App'
import { Auth0Plugin } from './auth';
import router from './router/index'
import store from './store'

import { iconsSet as icons } from './assets/icons/icons.js'
import { Icon }  from 'leaflet'
import 'leaflet/dist/leaflet.css'
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;

// vue-slider global
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import VueImg from 'v-img';

Vue.use(VueImg);
Vue.component('VueSlider', VueSlider)


Vue.use(CoreuiVue);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);


const domain = process.env.VUE_APP_AUTH0_DOMAIN;
const audience = process.env.VUE_APP_AUTH0_AUDIENCE;
const clientId = process.env.VUE_APP_AUTH0_CLIENT_ID;

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
});
